const forgetPassword = {
  title:  "نسيت كلمة المرور؟",
  subtitle: "ادخل البريد الالكترونى\nلاستعادة كلمة السر",
  labels: {
    email: "البريد الإلكتروني",
  },
  placeholders: {
    email: "ادخل البريد الالكتروني",
    password: "ادخل كلمة السر",
  },
  previous: "السابق",
  actionBTN: "إستعادة كلمة السر",
  enterNewPassword: "ادخل كلمة سر جديدة",
  resetSuccess: {
    title: "تم إرسال بريد إعادة التعيين!",
    description: "يرجى التحقق من صندوق الوارد لإعادة تعيين كلمة المرور.",
    button: "الانتقال لتسجيل الدخول",
  },
};

export default forgetPassword;
